/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebTokenInputModel
 */
export interface FrontWebTokenInputModel {
    /**
     * token
     * @type {string}
     * @memberof FrontWebTokenInputModel
     */
    token?: string;
}

/**
 * Check if a given object implements the FrontWebTokenInputModel interface.
 */
export function instanceOfFrontWebTokenInputModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FrontWebTokenInputModelFromJSON(json: any): FrontWebTokenInputModel {
    return FrontWebTokenInputModelFromJSONTyped(json, false);
}

export function FrontWebTokenInputModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebTokenInputModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}

export function FrontWebTokenInputModelToJSON(value?: FrontWebTokenInputModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

